import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import NotFound from '../views/notfound.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  { path: '*', component: NotFound }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
